import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import {isActiveToken} from '@/mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import Exchanges from "../views/Exchanges/Exchanges.vue";
import Handlers from "../views/Handlers/Handlers.vue";
import cfg from '../store/config';
import { AUTH_LOGOUT } from "@/store/const/user";


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/exchanges';
    if (!to.meta.access.includes(role)) {
      if (to.path === defaultRoute) {
        store.commit(`user/${AUTH_LOGOUT}`);
        next('/login');
      }
      return next(defaultRoute);
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    return next();
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: Exchanges,
          meta: {
            access: ['admin'],
            title: 'Обменки',
          }
        },
        {
          path: 'exchanges',
          name: 'Exchanges',
          beforeEnter: ifAuthenticated,
          component: Exchanges,
          meta: {
            access: ['admin'],
            title: 'Обменки',
          }
        },
        {
          path: 'handlers',
          name: 'Handlers',
          beforeEnter: ifAuthenticated,
          component: Handlers,
          meta: {
            access: ['admin'],
            title: 'Контроллеры',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});


let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
